import styled from 'styled-components';

export const CellRendererWrapper = styled('div')`
    display: flex;
    align-items: center;
    height: 100%;
`;
